module.exports = __webpack_public_path__ + "static/media/BwGlennSans700.4515dce1.woff";